import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import React from 'react'
import { Icon } from './Icon';

export function Required() {
  return (
    <Icon size="sm" color="red" icon={faAsterisk} placment="right"/>
  );
}
